import { render, staticRenderFns } from "./pushFbpConfiguration.vue?vue&type=template&id=3ecf37be&scoped=true"
import script from "./pushFbpConfiguration.vue?vue&type=script&lang=js"
export * from "./pushFbpConfiguration.vue?vue&type=script&lang=js"
import style0 from "./pushFbpConfiguration.vue?vue&type=style&index=0&id=3ecf37be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf37be",
  null
  
)

export default component.exports